import http from "@utils/request";

/** 获取充值列表 */
export const getOrders = (start_time,end_time,site_list,page=0,size=10) => http({
    method: "POST",
    url: "/phemsjava/getOrders",
    data: {
        start_time,end_time,site_list,page,size
    },
});

/**
 * 获取单价修改记录
 * @param {*} start_time 
 * @param {*} end_time 
 * @param {*} site_list 
 * @param {*} page 
 * @param {*} size 
 * @returns 
 */
export const getPriceRecord = (start_time,end_time,site_list,page=0,size=10) => http({
    method: "POST",
    url: "/phemsjava/getPriceRecord",
    data: {
        start_time,end_time,site_list,page,size
    },
});

/**
 * 获取错误修改记录
 * @param {*} start_time 
 * @param {*} end_time 
 * @param {*} site_list 
 * @param {*} page 
 * @param {*} size 
 * @returns 
 */
 export const getRechargeFailedRecord = (start_time,end_time,site_list,page=0,size=10) => http({
    method: "POST",
    url: "/phemsjava/getFailedRecord",
    data: {
        start_time,end_time,site_list,page,size
    },
});

/**
 * 根据数据库名称查询数据库分组信息
 * @param {*} dbname 
 * @returns 
 */
export const getSiteGroupByDatabase=(dbname)=>http({
    method:"GET",
    url:"/phemsjava/getSiteGroupByDatabase",
    data:{
        dbname
    }
})


/**
 * 充值
 * @param {*} siteno 
 * @param {*} price 
 * @param {*} total_price 
 * @returns 
 */
export const recharge=(siteno,price,amount,remaining_amount,old_price,old_amount,remaining_flux,old_price_time,orderid,time)=>http({
    method:"POST",
    url:"/phemsjava/recharge",
    data:{
        siteno,price,amount,remaining_amount,old_price,old_amount,remaining_flux,old_price_time,orderid,time
    },
    // 不显示加载框
    unloading:false
})

/**
 * 执行价格修改
 * @param {*} siteno 
 * @param {*} price 
 * @returns 
 */
export const updatePrice=(siteno,price,old_price,old_time,orderid,time)=>http({
    method:"POST",
    url:"/phemsjava/updatePrice",
    data:{
        siteno,price,old_price,old_time,orderid,time
    },
    // 不显示加载框
    unloading:false
})

/**
 * 获取设备数据，剩余金额，剩余流量和价格
 * @returns 
 */
export const getDeviceData=(siteno)=>http({
    method:"POST",
    url:"/phemsjava/getDeviceData",
    data:{
        siteno
    }
})

/**
 * 查询本数据库用户信息
 * @returns 
 */
export const getDatabaseUser=()=>http({
    method:"POST",
    url:"/user/getDatabaseUser",
})


/**
 * 发送微信通知
 * @param {*} templateid 
 * @param {*} templateparams 
 * @param {*} users 
 * @returns 
 */
 export const sendWxMsg=(templateid,templatetitle,templateparams,users)=>http({
    method:"POST",
    url:"/wx/sendMsg",
    data:{
      templateid,templatetitle,templateparams,users
    }
  });

  /**
 * 获取错误修改记录
 * @param {*} start_time 
 * @param {*} end_time 
 * @param {*} page 
 * @param {*} size 
 * @returns 
 */
 export const getWxMessageRecord = (start_time,end_time,page=0,size=10) => http({
    method: "POST",
    url: "/wx/getWxMessageRecord",
    data: {
        start_time,end_time,page,size
    },
});

/**
 * 获取全部正在处理的信息
 * @returns 
 */
export const getProcessing = () => http({
    method: "POST",
    url: "/phemsjava/getProcessing",
    // 不显示加载框
    unloading:false
});

/**
 * 取消定时单价修改
 * @returns 
 */
 export const canelPriceChange = (orderid) => http({
    method: "POST",
    url: "/phemsjava/canelPriceChange",
    data:{
        orderid
    }
});